import { adminHttpClient } from '../commons/adminHttpClient'

export type InsertCoverageProviderForMonthRequest = {
  startDate: string
  providerName: string
  policyName: string
  familyMemberId?: string
  attestation?: boolean
}

const insertCoverageProviderForMonth = (values: InsertCoverageProviderForMonthRequest): Promise<string> => {
  return adminHttpClient.post('Expenses/InsertCoverageProviderForMonth', values)
}

export default insertCoverageProviderForMonth
